import { render, staticRenderFns } from "./batchAdd.vue?vue&type=template&id=330d4b2c&scoped=true&"
import script from "./batchAdd.vue?vue&type=script&lang=js&"
export * from "./batchAdd.vue?vue&type=script&lang=js&"
import style0 from "./batchAdd.vue?vue&type=style&index=0&id=330d4b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d4b2c",
  null
  
)

export default component.exports